import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <footer className="page-footer bg-dark">
        <div className="container">
          <div className="justify-between gap-x-7 gap-y-14 md:flex  md:pt-24">
            <div className="">
              <Link to="/" className="hidden md:mb-6 md:inline-block">
                <img
                  src="/src/img/logo/logo.png"
                  className="w-32"
                  alt="BIG BANG X"
                />
              </Link>
              {/* <p className="mb-6 dark:text-gray-400">
                            Join us on a revolutionary journey as we redefine the NFT landscape with limitless posibilities. Welcome to the future of NFT marketplaces
                        </p> */}
              <div className="mt-5 flex space-x-5 md:mt-0">
                <a
                  href="https://x.com/bigbangplatform"
                  target="_blank"
                  className="group"
                >
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fab"
                    data-icon="twitter"
                    className="h-5 w-5 fill-jacarta-300 group-hover:fill-accent dark:group-hover:fill-white"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path>
                  </svg>
                </a>
                <a href="https://t.me/bigbangXio" className="group">
                  <svg
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    target="_blank"
                    className="bi bi-telegram h-5 w-5 fill-jacarta-300 group-hover:fill-accent dark:group-hover:fill-white"
                    viewBox="0 0 16 16"
                  >
                    {" "}
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />{" "}
                  </svg>
                </a>
                <a
                  href="https://garudauniverse.gitbook.io/bigbangx"
                  target="_blank"
                  className="group"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-file-text-fill fill-jacarta-300 group-hover:fill-accent dark:group-hover:fill-white"
                    viewBox="0 0 16 16"
                  >
                    <path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M5 4h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1m-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5M5 8h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1m0 2h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1" />
                  </svg>
                </a>
              </div>
            </div>

            {/* <div className="col-span-full sm:col-span-3 md:col-span-2 md:col-start-11">
                        <ul className="quick-links flex flex-col items-start space-y-1 dark:text-gray-400">
                            <li>
                                <Link to="/" className="dark:hover:text-jacarta-400">Home</Link>
                            </li>
                            <li>
                                <Link to="/collections/" className="dark:hover:text-jacarta-400">Explore Collections</Link>
                            </li>
                            <li>
                                <Link to="/profile/" className="dark:hover:text-jacarta-400">Profile</Link>
                            </li>
                        </ul>
                    </div> */}
            <div className="items-center space-y-2 py-2">
              <p className="text-sm dark:text-gray-400">
                &copy;
                <script>document.write(new Date().getFullYear())</script>
                BigbangX Marketplace - Developed by Garuda Universe &
                TriangulumX
              </p>
              <p className="text-sm dark:text-gray-400">
                Please DYOR before purchase/invest on NFTs Collection
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
